import { Component, HostListener, OnInit } from '@angular/core';
import { DistribuidorDeContenidosService } from '../servicio/distribuidor-de-contenidos.service';

@Component({
  selector: 'app-nuestro-trabajo',
  templateUrl: './nuestro-trabajo.component.html',
  styleUrls: ['./nuestro-trabajo.component.css']
})
export class NuestroTrabajoComponent implements OnInit {
  titulo: string;
  descripcion: string;
  datosTrabajo: { imagen: string; descripcion: string; }[];
  subtituloA: string
  subtituloB: string
  subtituloC: string
  equipoDescripcion: string
  imagenes: { path: string; }[];
  scrWidth: any;
  scrHeight: any;

  @HostListener('window:resize', ['$event'])

  getScreenSize(event?) {
    if (window.innerWidth > 640) {
      this.scrWidth = 700;
      this.scrHeight = 400;
    } else if (window.innerWidth > 400 && window.innerWidth <= 640) {
      this.scrWidth = window.innerWidth / 2;
      this.scrHeight = window.innerHeight / 2;
    } else {
      this.scrWidth = window.innerWidth;
      this.scrHeight = window.innerHeight / 3;
    }
  }
  constructor(private distribuidor: DistribuidorDeContenidosService) {
    this.getScreenSize();
    this.titulo = distribuidor.contenidoNuestroTrabajo.titulo
    this.descripcion = distribuidor.contenidoNuestroTrabajo.descripcion
    this.equipoDescripcion = distribuidor.contenidoNuestroTrabajo.equipoDescripcion
    this.subtituloA = distribuidor.contenidoNuestroTrabajo.subtituloA
    this.subtituloB = distribuidor.contenidoNuestroTrabajo.subtituloB
    this.imagenes = distribuidor.contenidoNuestroTrabajo.imagenes
    this.datosTrabajo = distribuidor.contenidoNuestroTrabajo.datosTrabajo
    this.subtituloC = distribuidor.contenidoNuestroTrabajo.subtituloC
  }

  ngOnInit(): void {

  }

}
